import { render, staticRenderFns } from "./SuccessfullyOrdered.vue?vue&type=template&id=67642d60&scoped=true"
import script from "./SuccessfullyOrdered.vue?vue&type=script&lang=js"
export * from "./SuccessfullyOrdered.vue?vue&type=script&lang=js"
import style0 from "./SuccessfullyOrdered.vue?vue&type=style&index=0&id=67642d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67642d60",
  null
  
)

export default component.exports